import { appTypeId } from '../../../models/application-types';

export class Controller {

    /** @ngInject */
    constructor($state, AddApplicationModal, AddNewApplicationResource) {
        this.$state = $state;
        this.AddApplicationModal = AddApplicationModal;
        this.AddNewApplicationResource = AddNewApplicationResource;
    }

    addDomainBoundComputerProtection() {
        this.appType$(appTypeId('computer-login')).get()
            .then(appType => this.AddApplicationModal(appType))
    }

    addByodComputerProtection() {
        this.AddNewApplicationResource
            .createSecureApp(this.companyId, appTypeId('computer-protection-without-ad'))
            .then(app => this.$state.go('company.manage-application', {appId: app.id}))
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/computer-protection/computer-protection.controller.js